module.exports = __webpack_public_path__ + "static/sport/bgi-dialog-pc.5daaaa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/bgi-dialog-pc.png
// module id = WDcB
// module chunks = 0